

export const index = 2;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/2.B_nYC3VT.js","_app/immutable/chunks/scheduler.CgctGpYI.js","_app/immutable/chunks/index.Dzy1rpav.js"];
export const stylesheets = [];
export const fonts = [];
